import generateAdjustedEventTraits from 'src/js/modules/element-settings/helpers/generate-adjusted-event-traits';
import generateChangedOptionsTraits from 'src/js/modules/element-settings/helpers/generate-changed-options-traits';
import filterStateByBreakpointKey from 'src/js/modules/element-settings/helpers/filter-state-by-breakpoint-key';
import { SubmitTraitsGenerationContract } from 'src/js/modules/element-settings/helpers/stage-contracts';
import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';
import { targetAttributes } from 'src/js/modules/element-settings/constants/target-attributes';
import { targetClasses } from 'src/js/modules/element-settings/constants/target-classes';

const getTraitName = (target) => {
  switch (target) {
    case targetAttributes.SURFACE: {
      return 'Surfaces';
    }

    case targetAttributes.HORIZONTAL_ALIGNMENT: {
      return 'HorizontalContentAlignment';
    }

    case targetAttributes.VERTICAL_ALIGNMENT: {
      return 'VerticalContentAlignment';
    }

    case targetClasses.ROUNDED_TOP_LEFT:
    case targetClasses.ROUNDED_TOP_RIGHT:
    case targetClasses.ROUNDED_BOTTOM_LEFT:
    case targetClasses.ROUNDED_BOTTOM_RIGHT: {
      return 'Corners';
    }

    case targetClasses.PADDING_TOP:
    case targetClasses.PADDING_BOTTOM:
    case targetClasses.COL_PADDING_LEFT:
    case targetClasses.COL_PADDING_RIGHT:
    case targetClasses.COLS_GAP_X:
    case targetClasses.GAP_Y: {
      return 'Spacing';
    }

    case targetClasses.COL: {
      return 'PerRow';
    }

    case targetClasses.GROW: {
      return 'Width';
    }

    case targetClasses.FLEX_DIRECTION:
    case targetClasses.FLEX_WRAP: {
      return 'Order';
    }

    case targetClasses.OUTER_SHADOW: {
      return 'Shadow';
    }

    case targetClasses.BORDER_TOP:
    case targetClasses.BORDER_RIGHT:
    case targetClasses.BORDER_BOTTOM:
    case targetClasses.BORDER_LEFT: {
      return 'Border';
    }

    case targetAttributes.HORIZONTAL_ALIGN:
    case targetAttributes.VERTICAL_ALIGN: {
      return 'Alignment';
    }

    // TODO: remove after migration. This is a temporary support for pages not yet migrated from attributes to classes by `ws-service`;
    case targetAttributes.BORDER: {
      return 'Border';
    }

    case targetAttributes.SHADOW: {
      return 'Shadow';
    }

    case targetAttributes.PADDING_TOP:
    case targetAttributes.PADDING_BOTTOM:
    case targetAttributes.PADDING_LEFT:
    case targetAttributes.PADDING_RIGHT:
    case targetAttributes.COLUMN_GAP:
    case targetAttributes.ROW_GAP: {
      return 'Spacing';
    }

    default: {
      return target;
    }
  }
};

const getAdjustedTraitsForBreakpoint = ({ prefix, stateByBreakpoint }) =>
  Object.values(stateByBreakpoint).reduce(
    (acc, targets) =>
      Object.keys(targets).reduce((targetsAcc, target) => {
        const adjustedTraits = generateAdjustedEventTraits(prefix, getTraitName(target), true);

        return {
          ...targetsAcc,
          ...adjustedTraits,
        };
      }, acc),
    {}
  );

const createSubmitTraitsColumnAppearanceHandler =
  ({ prefix, isBreakpointEditingEnabled = false }) =>
  (flowData, context) => {
    const { chunkStateDifference = {} } = context;

    const desktopTraits = getAdjustedTraitsForBreakpoint({
      prefix,
      stateByBreakpoint: filterStateByBreakpointKey(chunkStateDifference, breakpointKeys.DEFAULT),
    });
    const tabletTraits = isBreakpointEditingEnabled
      ? getAdjustedTraitsForBreakpoint({
          prefix,
          stateByBreakpoint: filterStateByBreakpointKey(
            chunkStateDifference,
            breakpointKeys.MAX_XL
          ),
        })
      : {};
    const mobileTraits = isBreakpointEditingEnabled
      ? getAdjustedTraitsForBreakpoint({
          prefix,
          stateByBreakpoint: filterStateByBreakpointKey(
            chunkStateDifference,
            breakpointKeys.MAX_MD
          ),
        })
      : {};

    const changedOptions = generateChangedOptionsTraits({
      desktopTraits,
      tabletTraits,
      mobileTraits,
    });

    return SubmitTraitsGenerationContract.create(changedOptions);
  };

export default createSubmitTraitsColumnAppearanceHandler;
